module.exports = __webpack_public_path__ + "img/ic-del.3f7ee764.svg";